import { JobDescription } from "../Beneficiary/job-description";

export class Option {
  value: number;
  viewValue: string;
}

export class LimitTypeMappingConfiguration {
  private limitType: Option;
  private limit: number;
  private isCashPurchase: boolean;

  private limitTypes: Array<Option> = [
    { value: 0, viewValue: "Individual" },
    { value: 1, viewValue: "Familiar" },
    //{ value: 2, viewValue: "Cargo" },
    { value: 2, viewValue: "Ilimitado" },

  ];

  setLimitType(type: number): void {
    this.limitType = this.limitTypes[type];
  }

  getLimitType(): Option {
    return this.limitType;
  }

  setLimit(limit: number): void {
    this.limit = limit;
  }

  getLimit(): number {
    return this.limit;
  }

  setIsCashPurchase(type: boolean): void {
    this.isCashPurchase = type;
  }

  getIsCashPurchase(): boolean {
    return this.isCashPurchase;
  }
}

export class JobDescriptionLimitConfiguration {
  private jobDescription: JobDescription;
  private limit: number;
  private isUnlimited: boolean;
  private inUse: number;

  setJobDescription(value: JobDescription): void {
    this.jobDescription = value;
  }

  getJobDescription(): JobDescription {
    return this.jobDescription;
  }

  setLimit(value: number): void {
    this.limit = value;
  }

  getLimit(): number {
    return this.limit;
  }

  setIsUnlimited(value: boolean): void {
    this.isUnlimited = value;
  }

  getisUnlimited(): boolean {
    return this.isUnlimited;
  }

  setInUse(value: number): void {
    this.inUse = value;
  }

  getInUse(): number {
    return this.inUse;
  }
}

export class JobDescriptionLimitMappingConfiguration {
  private jobDescriptionLimits: JobDescriptionLimitConfiguration[] = [];

  setJobDescriptionLimits(value: JobDescriptionLimitConfiguration[]): void {
    this.jobDescriptionLimits = value;
  }

  getJobDescriptionLimits(): JobDescriptionLimitConfiguration[] {
    return this.jobDescriptionLimits;
  }

  addLimitConfiguration(jobDescriptionLimitConfiguration: JobDescriptionLimitConfiguration): void {
    this.jobDescriptionLimits.push(jobDescriptionLimitConfiguration);
  }

  editLimitConfiguration(jobDescriptionLimitConfiguration: JobDescriptionLimitConfiguration): void {
    const index = this.jobDescriptionLimits.findIndex(
      (item) => item.getJobDescription().getKey() === jobDescriptionLimitConfiguration.getJobDescription().getKey(),
    );
    this.jobDescriptionLimits[index] = jobDescriptionLimitConfiguration;
  }

  deleteLimitConfiguration(jobDescriptionLimitConfiguration: JobDescriptionLimitConfiguration): void {
    this.jobDescriptionLimits.splice(this.jobDescriptionLimits.indexOf(jobDescriptionLimitConfiguration), 1);
  }

  hasLimitConfiguration(jobDescriptionLimitConfiguration: JobDescriptionLimitConfiguration): boolean {
    return this.jobDescriptionLimits.some((config) => config.getJobDescription().getKey() === jobDescriptionLimitConfiguration.getJobDescription().getKey());
  }
}

export class SocialNumberLimitConfiguration {
  private name: string;
  private socialNumber: string;
  private limit: number;
  private isUnlimited: boolean;

  setName(value: string): void {
    this.name = value;
  }

  getName(): string {
    return this.name;
  }

  setSocialNumber(value: string): void {
    this.socialNumber = value;
  }

  getSocialNumber(): string {
    return this.socialNumber;
  }

  setLimit(value: number): void {
    this.limit = value;
  }

  getLimit(): number {
    return this.limit;
  }

  setIsUnlimited(value: boolean): void {
    this.isUnlimited = value;
  }

  getisUnlimited(): boolean {
    return this.isUnlimited;
  }
}

export class SocialNumberLimitMappingConfiguration {
  private socialNumberLimits: SocialNumberLimitConfiguration[] = [];

  setSocialNumberLimits(value: SocialNumberLimitConfiguration[]): void {
    this.socialNumberLimits = value;
  }

  getSocialNumberLimits(): SocialNumberLimitConfiguration[] {
    return this.socialNumberLimits;
  }

  addLimitConfiguration(socialNumberLimitConfiguration: SocialNumberLimitConfiguration): void {
    this.socialNumberLimits.push(socialNumberLimitConfiguration);
  }

  editLimitConfiguration(socialNumberLimitConfiguration: SocialNumberLimitConfiguration): void {
    const index = this.socialNumberLimits.findIndex((item) => item.getSocialNumber() === socialNumberLimitConfiguration.getSocialNumber());
    this.socialNumberLimits[index] = socialNumberLimitConfiguration;
  }

  deleteLimitConfiguration(socialNumberLimitConfiguration: SocialNumberLimitConfiguration): void {
    this.socialNumberLimits.splice(this.socialNumberLimits.indexOf(socialNumberLimitConfiguration), 1);
  }

  hasLimitConfiguration(socialNumberLimitConfiguration: SocialNumberLimitConfiguration): boolean {
    return this.socialNumberLimits.some((config) => config.getSocialNumber() === socialNumberLimitConfiguration.getSocialNumber());
  }
}

export class TransactionConfiguration {
  private key: string;
  private companyFiscalNumber: string;
  private limitTypeMappingConfiguration = new LimitTypeMappingConfiguration();
  private jobDescriptionLimitMappingConfiguration = new JobDescriptionLimitMappingConfiguration();
  private socialNumberLimitMappingConfiguration = new SocialNumberLimitMappingConfiguration();

  setKey(key: string): void {
    this.key = key;
  }

  getKey(): string {
    return this.key;
  }

  setCompanyFiscalNumber(value): void {
    this.companyFiscalNumber = value;
  }

  getCompanyFiscalNumber(): string {
    return this.companyFiscalNumber;
  }

  setLimitTypeMappingConfiguration(value: LimitTypeMappingConfiguration): void {
    this.limitTypeMappingConfiguration = value;
  }

  getLimitTypeMappingConfiguration(): LimitTypeMappingConfiguration {
    return this.limitTypeMappingConfiguration;
  }

  setJobDescriptionLimitMappingConfiguration(value: JobDescriptionLimitMappingConfiguration): void {
    this.jobDescriptionLimitMappingConfiguration = value;
  }

  getJobDescriptionLimitMappingConfiguration(): JobDescriptionLimitMappingConfiguration {
    return this.jobDescriptionLimitMappingConfiguration;
  }

  setSocialNumberLimitMappingConfiguration(value: SocialNumberLimitMappingConfiguration): void {
    this.socialNumberLimitMappingConfiguration = value;
  }

  getSocialNumberLimitMappingConfiguration(): SocialNumberLimitMappingConfiguration {
    return this.socialNumberLimitMappingConfiguration;
  }

  isNew(): boolean {
    return !this.key;
  }
}
